// TODO - remove lint disable when editing this file
/* eslint-disable */
import { Observable } from 'rxjs'
import intl from 'react-intl-universal'
import { errorAction } from '~/redux/commonActions'
import { ACTION_WEBSKED_TASKS, setWebskedTasks } from '../websked'
import { getWebskedDisabled } from '~/redux/settingsReducer'

export default (action$, store, { serviceResolver }) =>
  action$
    .ofType(ACTION_WEBSKED_TASKS)
    .filter(() => !getWebskedDisabled(store.getState()))
    .mergeMap((action) => {
      const webskedService = serviceResolver('webskedService')
      return Observable.forkJoin(
        webskedService.getWebskedTasks(),
        webskedService.getWebSkedConfig()
      )
        .map((results) => {
          const [tasks, taskConfig] = results
          return setWebskedTasks({
            tasks,
            taskConfig,
          })
          // webskedService swallows http request error so unlikely this will occur
        })
        .catch(() =>
          Observable.of(
            errorAction(
              new Error(intl.get('epics.webskedTasksEpic.errors.fetchFailure'))
            )
          )
        )
    })
